<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useThemeStore } from "#/store/theme";

const { t } = useTranslation();

const themeStore = useThemeStore();
</script>

<template>
	<div class="center">
		<div class="stack">
			<h1 class="title_fiscal">{{ themeStore.data?.kiosk_waiting_for_card_payment_screen_text || t(`cart-complete.card-success.title`) }}</h1>
			<p class="reminder">{{ t(`cart-complete.card-success.subtitle`) }}</p>
			<div class="stageCard" aria-hidden="true">
				<div class="waves"><span></span><span></span><span></span></div>
				<div class="nfc">
					<svg viewBox="0 0 24 24" aria-hidden="true">
						<path d="M6 8c2.5 2.5 2.5 5.5 0 8" />
						<path d="M10 6c4 4 4 8 0 12" />
						<path d="M14 4c5.5 5.5 5.5 11 0 16" />
					</svg>
				</div>
				<div class="card">
					<div class="logo">inno.</div>
					<div class="chip"></div>
					<div class="digits">4815&nbsp;1623&nbsp;4200&nbsp;0900</div>
					<div class="holder">{{ t(`cart-complete.card-success.holder`) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
    @use './cartCompleteCardSuccess.scss';
</style>
